import inventoryAPI from '@/services/api/inventory2'
import _ from 'lodash'
import cookies from 'vue-cookies'

const state = {
	list: [],
	count: 0,
	loadParams: {
		offset: 0,
		length: 50,
		order: ['CREATE_DATETIME'],
		orderDirection: ['DESC'],
		keyword: '',
		startDatetime:
			(cookies.get('filter_history_date') || null)?.startDatetime || null,
		endDatetime:
			(cookies.get('filter_history_date') || null)?.endDatetime || null,
		types: JSON.parse(cookies.get('filter_history_types')) || [],
		categoriesId:
			JSON.parse(cookies.get('filter_history_categories')) || [],
		membersId: [],
		qrBarcode: '',
	},
	selectedItems: [],
	filter: null,
	filterCookieName: {
		types: 'filter_history_types',
		categoriesId: 'filter_history_categoriesId',
		date: 'filter_history_date',
	},
}

const getters = {
	list: state => state.list,
	filteredCount: state =>
		state.loadParams.types.length +
		state.loadParams.categoriesId.length +
		((state.loadParams.startDatetime ||
			state.loadParams.endDatetime ||
			null) != null
			? 1
			: 0),
	filteredList: state => {
		return {
			types: state.loadParams.types,
			categoriesId: state.loadParams.categoriesId,
			date: {
				startDatetime: state.loadParams.startDatetime,
				endDatetime: state.loadParams.endDatetime,
			},
		}
	},
	order: state => state.loadParams.order[0],
	orderDirection: state => state.loadParams.orderDirection[0],
}

const mutations = {
	setList: (state, data) => {
		state.list = [...state.list, ...data.list]
		state.count = data.count
		state.loadParams.offset = state.list.length
	},
	setLoadParams: (state, loadParams) => {
		if (loadParams != null)
			Object.keys(loadParams).forEach(key => {
				if (key == 'date') {
					state.loadParams.startDatetime =
						loadParams[key].startDatetime
					state.loadParams.endDatetime = loadParams[key].endDatetime
				} else {
					state.loadParams[key] = loadParams[key]
				}
			})
	},
	setFilter: (state, data) => {
		state.filter = data
	},
	setSelectedItems: (state, data) => {
		state.selectedItems = data
	},
	initOffset: state => {
		state.loadParams.offset = 0
		state.list = []
	},
	initFilterCookies: (state, needReset) => {
		if (needReset)
			Object.values(state.filterCookieName).forEach(key => {
				cookies.set(key, JSON.stringify([]))
			})
		state.loadParams = {
			offset: 0,
			length: 50,
			order: ['CREATE_DATETIME'],
			orderDirection: ['DESC'],
			keyword: '',
			startDatetime:
				(cookies.get('filter_history_date') || null)?.startDatetime ||
				null,
			endDatetime:
				(cookies.get('filter_history_date') || null)?.endDatetime ||
				null,
			types: JSON.parse(cookies.get('filter_history_types')) || [],
			categoriesId:
				JSON.parse(cookies.get('filter_history_categories')) || [],
			membersId: [],
			qrBarcode: '',
		}
	},
}

const actions = {
	getList: async ({ state, commit, rootGetters }, isMore = false) => {
		if (!isMore) commit('initOffset')
		const response = await inventoryAPI.getHistory(
			rootGetters.instituteId,
			state.loadParams
		)
		commit('setList', response.data)
	},
	getFilter: async ({ commit, rootGetters }) => {
		const response = await inventoryAPI.getHistoryFilter(
			rootGetters.instituteId
		)
		commit('setFilter', response.data)
	},
	getItemCount: async ({ rootGetters, state }, filterPararms) => {
		const response = await inventoryAPI.getHistory(
			rootGetters.instituteId,
			{
				itemId: state.loadParams.itemId,
				...filterPararms,
			}
		)
		return response.data.count
	},
	setLoadParams: async ({ commit, dispatch }, loadParams) => {
		commit('setLoadParams', loadParams)
		dispatch('getList')
	},
	deleteHistory: async ({ rootGetters, dispatch }, ids) => {
		const response = await inventoryAPI.deleteHistory(
			rootGetters.instituteId,
			{ ids }
		)
		if (response.status == 205) dispatch('getList')
		return response
	},
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
}
